/**
 * local storage properties
 */
export const CURRENT_USER = 'user'; // todo should be as: trinityApp.currentUser
export const ACCESS_TOKEN = 'AccessToken'; // todo should be as: trinityApp.accessToken
export const REFRESH_TOKEN = 'refreshToken'; // todo should be as: trinityApp.refreshToken
export const TIME_ZONE_DATA = 'timeZoneData'; // todo: added temporary for the back compatibility. Remove it in future
export const MEMBER_PREFERENCE_SETTINGS = 'MemberPreferenceSettings';
export const DASHBOARD_FILTER = 'trinityApp.dashboardFilter';
export const SERVICE_REQUEST_DETAILS = 'trinityApp.serviceRequestDetails';
export const SERVICE_REQUEST_NOTES = 'trinityApp.serviceRequest.notes';
export const SERVICE_REQUEST_FILES = 'trinityApp.serviceRequest.files';
export const SERVICE_REQUEST_MEMBERS = 'trinityApp.serviceRequest.members';
export const SERVICE_REQUEST_DROP_OFF_LOCATION_DETAILS = 'trinityApp.serviceRequest.dropOffLocationDetails';
export const CURRENT_TIMEZONE = 'trinityApp.currentTimezone';
export const SERVICE_REQUEST_PREFERENCES = 'trinityApp.serviceRequestPreferences';
export const DRIVER_REGION = 'trinityApp.driverRegion';
